import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * If a user opens any non-admin URL that carries `?type=recovery` (or
 * `?type=invite`) in the query string or hash, forward them to the admin
 * reset-password page while preserving all params. This protects users who
 * click older emails whose button URL pointed at the site root.
 */
const RecoveryLinkRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.startsWith("/admin/reset-password")) return;

    const search = new URLSearchParams(location.search);
    const hash = new URLSearchParams(location.hash.replace(/^#/, ""));
    const type = search.get("type") || hash.get("type");
    if (type !== "recovery" && type !== "invite") return;

    navigate(
      {
        pathname: "/admin/reset-password",
        search: location.search,
        hash: location.hash,
      },
      { replace: true },
    );
  }, [location, navigate]);

  return null;
};

export default RecoveryLinkRedirect;
